import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v38.1.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import t from "@arcgis/core/layers/GraphicsLayer";
import e from "@arcgis/core/Graphic";
import * as i from "@arcgis/core/geometry/geometryEngine";
import o from "@arcgis/core/widgets/Sketch/SketchViewModel";
import { A as s, L as r } from "../utils/auto-pan.js";
import { D as a, H as l } from "../delta-history-manager.js";
import { L as n } from "../label-manager.js";
import "../zone-classification.js";
import "@arcgis/core/geometry/Geometry";
import "../utils/map.js";
import "@arcgis/core/geometry/Polygon";
import "../api/rec.js";
import { N as h } from "../non-field-feature.js";
import "@arcgis/core/geometry/SpatialReference";
import "@arcgis/core/tasks/Locator";
import "@arcgis/core/geometry/support/webMercatorUtils";
import "@arcgis/core/geometry/support/jsonUtils";
import "@arcgis/core/geometry/projection";
import "@terraformer/arcgis";
import { T as c } from "../index.js";
import "uuid";
import "lodash";
import { G as p, b as d } from "../geometry/utils.js";
import "@arcgis/core/Basemap";
import { C as g, T as m } from "../enums.js";
import { S as y } from "../symbols.js";
import { Map as b } from "immutable";
var _ = h;

var AcreageLabel = /*#__PURE__*/function () {
  function AcreageLabel(t) {
    _classCallCheck(this, AcreageLabel);

    this._manager = new n(t);
  }

  _createClass(AcreageLabel, [{
    key: "move",
    value: function move(t) {
      this._manager.moveLabel(t);
    }
  }, {
    key: "update",
    value: function update(t) {
      if (!t || t.rings[0].length <= 3) return void this._manager.clearLabel();

      var e = p.getPolyLabelPoint(t, c.labelPlacementPrecision),
          i = this._acreageText(t);

      this._manager.updateLabel(e, i);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._manager.clearLabel();
    }
  }, {
    key: "_acreageText",
    value: function _acreageText(t) {
      var e = d.calculateRawArea(t, c.drawTools.areaUnits.esriUnit);
      return "".concat(Math.round(100 * e) / 100, " ").concat(c.drawTools.areaUnits.label);
    }
  }]);

  return AcreageLabel;
}();

var Symbols = function Symbols(t, e, i) {
  _classCallCheck(this, Symbols);

  this.basic = t, this.editing = e, this.invalid = i;
};

var MapObject = /*#__PURE__*/function () {
  function MapObject(t, e, i) {
    _classCallCheck(this, MapObject);

    this.graphic = t, this.userData = e, this._symbols = i, this._isEditing = !1;
  }

  _createClass(MapObject, [{
    key: "clone",
    value: function clone() {
      var t = this.graphic.clone();
      return t.symbol = this._determineEditingSymbol(), new MapObject(t, this.userData, this._symbols);
    }
  }, {
    key: "onEditStarted",
    value: function onEditStarted() {
      this._isEditing || (this._isEditing = !0);
    }
  }, {
    key: "onEditStopped",
    value: function onEditStopped() {
      this._isEditing && (this._isEditing = !1);
    }
  }, {
    key: "_determineEditingSymbol",
    value: function _determineEditingSymbol() {
      return this._isEditing ? this._symbols.editing : this._symbols.basic;
    }
  }]);

  return MapObject;
}();

var MapPolygon = /*#__PURE__*/function (_MapObject) {
  _inherits(MapPolygon, _MapObject);

  var _super = _createSuper(MapPolygon);

  function MapPolygon(t, e) {
    _classCallCheck(this, MapPolygon);

    return _super.call(this, t, e, new Symbols(y.fromJSON(c.symbols.draw.nonFieldFeature.polygon), y.fromJSON(c.symbols.draw.nonFieldFeature.highlight.polygon), y.fromJSON(c.symbols.draw.nonFieldFeature.invalid.polygon)));
  }

  _createClass(MapPolygon, [{
    key: "simplify",
    value: function simplify() {
      this.graphic.geometry = i.simplify(this.graphic.geometry);
    }
  }]);

  return MapPolygon;
}(MapObject);

var MapPolyline = /*#__PURE__*/function (_MapObject2) {
  _inherits(MapPolyline, _MapObject2);

  var _super2 = _createSuper(MapPolyline);

  function MapPolyline(t, e) {
    _classCallCheck(this, MapPolyline);

    return _super2.call(this, t, e, new Symbols(y.fromJSON(c.symbols.draw.nonFieldFeature.polyline), y.fromJSON(c.symbols.draw.nonFieldFeature.highlight.polyline), y.fromJSON(c.symbols.draw.nonFieldFeature.invalid.polyline)));
  }

  _createClass(MapPolyline, [{
    key: "simplify",
    value: function simplify() {
      this.graphic.geometry = i.simplify(this.graphic.geometry);
    }
  }]);

  return MapPolyline;
}(MapObject);

var MapPoint = /*#__PURE__*/function (_MapObject3) {
  _inherits(MapPoint, _MapObject3);

  var _super3 = _createSuper(MapPoint);

  function MapPoint(t, e) {
    _classCallCheck(this, MapPoint);

    return _super3.call(this, t, e, new Symbols(y.fromJSON(c.symbols.draw.nonFieldFeature.point), y.fromJSON(c.symbols.draw.nonFieldFeature.highlight.point), y.fromJSON(c.symbols.draw.nonFieldFeature.invalid.polygon)));
  }

  return MapPoint;
}(MapObject);

var Tool = /*#__PURE__*/function () {
  function Tool(t, e, i, o, s, r, a) {
    _classCallCheck(this, Tool);

    this.type = i, this._mapView = t, this._layer = e, this._symbol = o, this.editToolbar = a, this._geometryType = r, this.ui = null, this.drawnPoints = [];
  }

  _createClass(Tool, [{
    key: "unselect",
    value: function unselect() {
      this.ui && this.ui.unselect(!0);
    }
  }, {
    key: "activate",
    value: function activate() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.drawnPoints = t, this._mapView.container.style.cursor = g.crosshair;
      var e = "DrawCircle" === this.type ? "freehand" : "click";
      this.editToolbar.create(this._geometryType, {
        mode: e
      });
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      this.drawnPoints = [], this._mapView.container.style.cursor = g.default;
    }
  }, {
    key: "setCreatorPoints",
    value: function setCreatorPoints() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      0 !== t.length ? this.activate(t) : this.deactivate();
    }
  }, {
    key: "getNextGraphicId",
    value: function getNextGraphicId(t) {
      var e = [];
      return t.forEach(function (t) {
        t.attributes && t.attributes.id && e.push(t.attributes.id);
      }), Math.max.apply(Math, e.concat([0])) + 1;
    }
  }, {
    key: "onDraw",
    value: function onDraw(_ref) {
      var t = _ref.finished,
          e = _ref.graphic;
      t && this._onFinishedDraw(e);
    }
  }, {
    key: "_onFinishedDraw",
    value: function _onFinishedDraw(t) {
      var e = t.geometry;
      e.hasOwnProperty("radius") && (e = i.simplify(e)), this.selectedId = this.getNextGraphicId(this._layer.graphics);

      var o = this._layer.graphics.find(function (t) {
        return i.equals(t.geometry, e);
      });

      o && (o.attributes.id = this.selectedId), this.drawnPoints = [];
      var s = new _();
      s.shape = e;

      var r = this._createMapObject(t, s);

      this.onFinishedDraw && this.onFinishedDraw(r);
    }
  }]);

  return Tool;
}();

var PolygonTool = /*#__PURE__*/function (_Tool) {
  _inherits(PolygonTool, _Tool);

  var _super4 = _createSuper(PolygonTool);

  function PolygonTool(t, e, i, o, s) {
    _classCallCheck(this, PolygonTool);

    return _super4.call(this, t, e, m.DrawPolygon, i, o, "polygon", s);
  }

  _createClass(PolygonTool, [{
    key: "_createMapObject",
    value: function _createMapObject(t, e) {
      return new MapPolygon(t, e);
    }
  }, {
    key: "onFinishedDraw",
    value: function onFinishedDraw(t, e) {}
  }]);

  return PolygonTool;
}(Tool);

var PolylineTool = /*#__PURE__*/function (_Tool2) {
  _inherits(PolylineTool, _Tool2);

  var _super5 = _createSuper(PolylineTool);

  function PolylineTool(t, e, i, o, s) {
    _classCallCheck(this, PolylineTool);

    return _super5.call(this, t, e, m.DrawPolyline, i, o, "polyline", s);
  }

  _createClass(PolylineTool, [{
    key: "_createMapObject",
    value: function _createMapObject(t, e) {
      return new MapPolyline(t, e);
    }
  }, {
    key: "onFinishedDraw",
    value: function onFinishedDraw(t, e) {}
  }]);

  return PolylineTool;
}(Tool);

var CircleTool = /*#__PURE__*/function (_Tool3) {
  _inherits(CircleTool, _Tool3);

  var _super6 = _createSuper(CircleTool);

  function CircleTool(t, e, i, o, s) {
    _classCallCheck(this, CircleTool);

    return _super6.call(this, t, e, m.DrawCircle, i, o, "circle", s);
  }

  _createClass(CircleTool, [{
    key: "_createMapObject",
    value: function _createMapObject(t, e) {
      return new MapPolygon(t, e);
    }
  }, {
    key: "onFinishedDraw",
    value: function onFinishedDraw(t, e) {}
  }]);

  return CircleTool;
}(Tool);

var PointTool = /*#__PURE__*/function (_Tool4) {
  _inherits(PointTool, _Tool4);

  var _super7 = _createSuper(PointTool);

  function PointTool(t, e, i, o, s) {
    _classCallCheck(this, PointTool);

    return _super7.call(this, t, e, m.DrawPoint, i, o, "point", s);
  }

  _createClass(PointTool, [{
    key: "_createMapObject",
    value: function _createMapObject(t, e) {
      return new MapPoint(t, e);
    }
  }, {
    key: "onFinishedDraw",
    value: function onFinishedDraw(t, e) {}
  }]);

  return PointTool;
}(Tool);

var MapObjects = /*#__PURE__*/function () {
  function MapObjects(t, e) {
    _classCallCheck(this, MapObjects);

    this._layer = t, this._onSetGeometries = e, this._objects = [], this._graphicsToObjects = b(), this.parkedEditingObject = null, this.editingObject = null;
  }

  _createClass(MapObjects, [{
    key: "set",
    value: function set(t) {
      this.stopEditing(), this._objects = t, this._graphicsToObjects = b();

      var _iterator = _createForOfIteratorHelper(t),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;
          this._graphicsToObjects = this._graphicsToObjects.set(_e.graphic.attributes.id, _e);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._dispatchGeometries();
    }
  }, {
    key: "modify",
    value: function modify() {
      var _this = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        add: [],
        remove: []
      };
      var e = t.add ? t.add : [],
          i = t.remove ? t.remove : [];
      i.some(function (t) {
        return t === _this.editingObject;
      }) && this.stopEditing();

      var _iterator2 = _createForOfIteratorHelper(i),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _o = _step2.value;
          this._graphicsToObjects = this._graphicsToObjects.delete(_o.graphic.attributes.id);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(e),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _o2 = _step3.value;
          this._graphicsToObjects = this._graphicsToObjects.set(_o2.graphic.attributes.id, _o2);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this._objects = this._objects.filter(function (t) {
        return !i.includes(t);
      }).concat(e), this._dispatchGeometries();
    }
  }, {
    key: "startEditing",
    value: function startEditing(t) {
      console.assert(this._objects.includes(t)), this.stopEditing(), this.parkedEditingObject = t;
      var e = this.parkedEditingObject;
      this.editingObject = e.clone(), this.modify({
        add: [this.editingObject],
        remove: [e]
      }), this.editingObject.onEditStarted();
    }
  }, {
    key: "stopEditing",
    value: function stopEditing() {
      if (!this.editingObject) return;
      var t = this.editingObject,
          e = this.parkedEditingObject;
      this.parkedEditingObject = null, this.editingObject = null, t.onEditStopped(), this.modify({
        add: [e],
        remove: [t]
      });
    }
  }, {
    key: "objectFromGraphic",
    value: function objectFromGraphic(t) {
      return this._graphicsToObjects.get(t.attributes.id);
    }
  }, {
    key: "_dispatchGeometries",
    value: function _dispatchGeometries() {
      var t = this._objects.map(function (t) {
        return t.userData;
      });

      this._onSetGeometries(t);
    }
  }]);

  return MapObjects;
}();

var u = Object.freeze({
  __proto__: null,
  AcreageLabel: AcreageLabel,
  Symbols: Symbols,
  MapObject: MapObject,
  MapPolygon: MapPolygon,
  MapPolyline: MapPolyline,
  MapPoint: MapPoint,
  Tool: Tool,
  PolygonTool: PolygonTool,
  PolylineTool: PolylineTool,
  CircleTool: CircleTool,
  PointTool: PointTool,
  MapObjects: MapObjects,
  Editor: /*#__PURE__*/function () {
    function Editor(e, i, r, l, n, h) {
      var _this2 = this;

      _classCallCheck(this, Editor);

      this._mapView = e;
      this._layer = i("NON_FIELD_FEATURES_DRAW_TOOLS_LAYER"), this._labelLayer = new t(), this._mapView.map.add(this._labelLayer), this._allLayers = [this._layer, this._labelLayer], this._acreageLabel = new AcreageLabel(this._labelLayer), this._allListenerManagers = [], this._polygonSymbol = y.fromJSON(c.symbols.draw.nonFieldFeature.polygon), this._polylineSymbol = y.fromJSON(c.symbols.draw.nonFieldFeature.polyline), this._pointSymbol = y.fromJSON(c.symbols.draw.nonFieldFeature.point), this._pointHighlightSymbol = y.fromJSON(c.symbols.draw.nonFieldFeature.highlight.point), this._polygonHighlightSymbol = y.fromJSON(c.symbols.draw.nonFieldFeature.highlight.polygon), this._polylineHighlightSymbol = y.fromJSON(c.symbols.draw.nonFieldFeature.highlight.polyline), this._invalidSymbol = y.fromJSON(c.symbols.draw.nonFieldFeature.invalid.polygon), this._editToolbar = new o({
        activeFillSymbol: this._polygonSymbol,
        pointSymbol: this._pointSymbol,
        polylineSymbol: this._polylineSymbol,
        view: e,
        layer: this._layer,
        defaultUpdateOptions: {
          enableZ: !1,
          multipleSelectionEnabled: !1,
          preserveAspectRatio: !0,
          reshapeOptions: {
            shapeOperation: "none"
          }
        },
        updateOnGraphicClick: !1
      });

      var createTool = function createTool(t, i) {
        return new t(e, _this2._layer, i, _this2._invalidSymbol, _this2._editToolbar);
      };

      this.polygonTool = createTool(PolygonTool, y.fromJSON(c.symbols.draw.nonFieldFeature.polygon)), this.polygonTool.onFinishedDraw = this.finalizeDraw.bind(this), this.polylineTool = createTool(PolylineTool, y.fromJSON(c.symbols.draw.nonFieldFeature.polyline)), this.polylineTool.onFinishedDraw = this.finalizeDraw.bind(this), this.circleTool = createTool(CircleTool, y.fromJSON(c.symbols.draw.nonFieldFeature.polygon)), this.circleTool.onFinishedDraw = this.finalizeDraw.bind(this), this.pointTool = createTool(PointTool, this._pointSymbol), this.pointTool.onFinishedDraw = this.finalizeDraw.bind(this), this.allTools = [this.polygonTool, this.circleTool, this.pointTool, this.polylineTool], this._autoPan = new s(e), this._autoPan.setEditToolbar(this._editToolbar), this._mapObjects = new MapObjects(this._layer, n), this._history = new a(), this._retrieveMenu = r, this._moveLayersToTop = l, this._setActiveMapTool = h;
    }

    _createClass(Editor, [{
      key: "destroy",
      value: function destroy() {
        var _iterator4 = _createForOfIteratorHelper(this._allListenerManagers),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _t = _step4.value;

            _t.removeAll();
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this._editToolbar.destroy();
      }
    }, {
      key: "clear",
      value: function clear() {
        this._mapObjects.set([]), this._editingFeature = null, this._history = new a(), this._acreageLabel.clear();
      }
    }, {
      key: "reset",
      value: function reset(t) {
        var _this3 = this;

        return new Promise(function (e) {
          if (_this3._mapView.container.style.cursor = g.default, _this3.resetEditing(!1, !1), _this3._setActiveMapTool({
            tool: null
          }), _this3._autoPan.deactivate(), t) return void e();
          _this3._editToolbar.cancel(), _this3._layer.removeAll();

          var _iterator5 = _createForOfIteratorHelper(_this3._allListenerManagers),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _t2 = _step5.value;

              _t2.removeAll();
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          _this3._allListenerManagers = [];

          var i = _this3.allTools.map(function (t) {
            return t.deactivate();
          });

          Promise.all(i).then(function () {
            e();
          });
        });
      }
    }, {
      key: "activateTool",
      value: function activateTool(t) {
        var e = this.toolFromType(t);
        e && e.activate(), this._autoPan.activate(), this._editingFeature = null, this._acreageLabel.clear(), this.setSymbols();
      }
    }, {
      key: "toggleTool",
      value: function toggleTool(t) {
        this.resetEditing(!1, !1), this._mapView.container.style.cursor = g.default, this._activeMapTool = this.allTools[t], this._setActiveMapTool({
          tool: m[this._activeMapTool.type],
          activate: !0,
          byPassShare: !1,
          forceUpdate: !1
        }), this._moveLayersToTop(this._allLayers);
      }
    }, {
      key: "deselectTools",
      value: function deselectTools() {
        this.allTools.map(function (t) {
          return t.ui;
        }).some(function (t) {
          return !!t && (t.unselect(!0), !0);
        });

        var t = this._retrieveMenu();

        t && t.toggleTool({
          selected: !1
        }), this._activeMapTool = null, this._setActiveMapTool({
          tool: null,
          activate: !1
        });

        var _iterator6 = _createForOfIteratorHelper(this.allTools),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _e2 = _step6.value;

            _e2.deactivate();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        this._autoPan.deactivate(), this._mapView.container.style.cursor = g.default;
      }
    }, {
      key: "attemptDeleteEditingObject",
      value: function attemptDeleteEditingObject() {
        var _this4 = this;

        if (!this._mapObjects.editingObject) return;
        var t = this._mapObjects.parkedEditingObject,
            e = new l(function () {
          _this4.removeGraphic(t);
        }, function () {
          _this4.addGraphic(t);
        });
        this.addHistory(a.prototype.push, e), this._acreageLabel.clear();
      }
    }, {
      key: "isEditingObject",
      value: function isEditingObject() {
        return Boolean(this._mapObjects.editingObject);
      }
    }, {
      key: "forwardHistory",
      value: function forwardHistory() {
        this.resetEditing(!0, !0), this._history.forward();
      }
    }, {
      key: "reverseHistory",
      value: function reverseHistory() {
        this.resetEditing(!0, !0), this._history.reverse();
      }
    }, {
      key: "canForwardHistory",
      value: function canForwardHistory() {
        return this._history.canForward();
      }
    }, {
      key: "canReverseHistory",
      value: function canReverseHistory() {
        return this._history.canReverse();
      }
    }, {
      key: "setFeature",
      value: function setFeature(t) {
        var _this5 = this;

        if (t === this._editingFeature) return;
        this._editingFeature = t;
        var i = this._layer.graphics.length < 1,
            o = t.geometries.map(function (t) {
          var o = t.shape;
          var s, r;
          if (p.isPolygon(o)) s = MapPolygon, r = _this5._polygonSymbol;else if (p.isPoint(o)) s = MapPoint, r = _this5._pointSymbol;else {
            if (!p.isPolyline(o)) return null;
            s = MapPolyline, r = _this5._polylineSymbol;
          }
          var a = new e({
            attributes: {
              id: _this5.getNextGraphicId(_this5._layer.graphics)
            },
            geometry: o,
            symbol: r
          });
          return i && _this5._layer.add(a), new s(a, t);
        }).filter(function (t) {
          return !!t;
        });
        this._mapObjects.set(o), this.setListeners();
      }
    }, {
      key: "setListeners",
      value: function setListeners() {
        if (this._allListenerManagers.length > 0) return;
        var t = new r(),
            e = new r();
        this._allListenerManagers.push(t, e), this.createMapListeners(t), this.createEditToolbarListeners(e);
      }
    }, {
      key: "setToolbarMenuInset",
      value: function setToolbarMenuInset(t) {
        var e = t ? [t] : [];
        return this._autoPan.setInsets(e), e;
      }
    }, {
      key: "mapScale",
      value: function mapScale() {
        return this._mapView.scale;
      }
    }, {
      key: "addGraphic",
      value: function addGraphic(t) {
        this._mapObjects.modify({
          add: [t],
          remove: []
        }), t.graphic.symbol = this.getSymbol(t.graphic.geometry.type, 0), this._layer.add(t.graphic);
      }
    }, {
      key: "getNextGraphicId",
      value: function getNextGraphicId(t) {
        var e = [];
        return t.forEach(function (t) {
          t.attributes && t.attributes.id && e.push(t.attributes.id);
        }), Math.max.apply(Math, e.concat([0])) + 1;
      }
    }, {
      key: "startEditing",
      value: function startEditing(t) {
        this._mapObjects.startEditing(t), this.activateEditToolbar(t);
      }
    }, {
      key: "onEdit",
      value: function onEdit(t) {
        var e = this._mapObjects.parkedEditingObject,
            i = this._mapObjects.editingObject,
            o = t.geometry,
            s = p.clone(i.graphic.geometry),
            r = "polygon" === o.type;
        if (!(!r || this.isValidPolygon(e.graphic.geometry))) return e.graphic.geometry = s, void this.resetEditing(!0, !0);

        var mapObjectModification = function mapObjectModification(t) {
          return function () {
            e.graphic.geometry = p.clone(t), e.userData.shape = p.clone(t);
          };
        },
            n = new l(mapObjectModification(o), mapObjectModification(s));

        this.addHistory(a.prototype.push, n), r && this._acreageLabel.update(o), e.graphic.geometry = p.clone(o), e.userData.shape = p.clone(o), this._mapObjects.editingObject.graphic.geometry = o, this._mapObjects.modify({
          add: [],
          remove: []
        });
      }
    }, {
      key: "finalizeDraw",
      value: function finalizeDraw(t) {
        if (!t) return;
        var e = this.drawFinalizationHistoryMoment(t);
        this.addHistory(a.prototype.checkpoint, e), this.deselectTools(), this._editToolbar.complete(), this._mapObjects.modify({
          add: [],
          remove: []
        }), this._selectedGraphic = t.graphic, this.startEditing(t);
      }
    }, {
      key: "drawFinalizationHistoryMoment",
      value: function drawFinalizationHistoryMoment(t) {
        var _this6 = this;

        return new l(function () {
          _this6.addGraphic(t);
        }, function () {
          _this6.removeGraphic(t);
        });
      }
    }, {
      key: "drawMidHistoryMoment",
      value: function drawMidHistoryMoment() {
        var _this7 = this;

        return new l(function () {
          _this7._editToolbar.redo();
        }, function () {
          _this7._editToolbar.undo();
        });
      }
    }, {
      key: "addHistory",
      value: function addHistory(t, e) {
        t.call(this._history, e.forward, e.reverse);
      }
    }, {
      key: "toolFromType",
      value: function toolFromType(t) {
        switch (t) {
          case m.DrawPolygon:
            return this.polygonTool;

          case m.DrawCircle:
            return this.circleTool;

          case m.DrawPoint:
            return this.pointTool;

          case m.DrawPolyline:
            return this.polylineTool;

          default:
            return null;
        }
      }
    }, {
      key: "activateEditToolbar",
      value: function activateEditToolbar(t) {
        var _this8 = this;

        var e = t.graphic,
            i = "polygon" === e.geometry.type || "polyline" === e.geometry.type ? "reshape" : "move";
        this._editToolbar.update(e, {
          tool: i,
          toggleToolOnClick: !1,
          enableScaling: !1,
          enableRotation: !1
        }), setTimeout(function () {
          _this8.setSymbols(e);
        }, 0);
      }
    }, {
      key: "createEditToolbarListeners",
      value: function createEditToolbarListeners(t) {
        var _this9 = this;

        t.add(this._editToolbar.on("update", function (t) {
          var e = _this9._mapObjects.parkedEditingObject;

          if (e && "point" === e.graphic.geometry.type && (e.graphic.symbol = _this9._pointHighlightSymbol), e && "polyline" === e.graphic.geometry.type && (e.graphic.symbol = _this9._polylineHighlightSymbol), e && "polygon" === e.graphic.geometry.type) {
            _this9._acreageLabel.update(e.graphic.geometry);

            var _t3 = _this9.isValidPolygon(e.graphic.geometry);

            e.graphic.symbol = _t3 ? _this9._polygonHighlightSymbol : _this9._invalidSymbol;
          }

          t.toolEventInfo && ["move-stop", "rotate-stop", "scale-stop", "vertex-remove", "reshape-stop"].includes(t.toolEventInfo.type) && _this9.onEdit(t.graphics[0]);
        })), t.add(this._editToolbar.on("create", function (t) {
          var e = _this9._activeMapTool && ["DrawCircle", "DrawPolygon"].includes(_this9._activeMapTool.type);
          var o = null;

          if (_this9._isValidDrawing = !0, t.graphic && (o = _this9._layer.graphics.find(function (e) {
            return i.equals(e.geometry, t.graphic.geometry);
          }), e && (_this9._isValidDrawing = _this9.isValidPolygon(t.graphic.geometry), _this9._editToolbar.activeFillSymbol = _this9._isValidDrawing ? _this9._polygonSymbol : _this9._invalidSymbol, _this9._acreageLabel.update(t.graphic.geometry))), "start" === t.state && _this9._moveLayersToTop([_this9._labelLayer]), "complete" === t.state) {
            if (!_this9._isValidDrawing) return void _this9._editToolbar.update(t.graphic);
            _this9._mapView.container.style.cursor = g.default;
            var _e3 = t.graphic.geometry;
            _this9._activeMapTool.selectedId = _this9.getNextGraphicId(_this9._layer.graphics), o && (o.attributes = {}, o.attributes.id = _this9._activeMapTool.selectedId), _this9._activeMapTool.drawnPoints = [];
            new _().shape = _e3, _this9._activeMapTool.onDraw && _this9._activeMapTool.onDraw({
              finished: !0,
              graphic: o
            });
          }
        }));
      }
    }, {
      key: "createMapListeners",
      value: function createMapListeners(t) {
        var _this10 = this;

        var onMouseUp = function onMouseUp(t) {
          if (t) {
            var _e4 = _this10._mapObjects.objectFromGraphic(t);

            _e4 && _e4 !== _this10._mapObjects.editingObject ? (_this10._selectedGraphic = t, _this10._acreageLabel.clear(), _this10.startEditing(_e4)) : _e4 && !_this10._editToolbar.activeTool && onClickOffFeature();
          }
        },
            isDrawing = function isDrawing() {
          var t = _this10._editToolbar.activeTool;
          return ["circle", "polygon", "point", "polyline"].includes(t);
        },
            onClickOffFeature = function onClickOffFeature(t, e) {
          t || isDrawing() || e || (_this10.resetEditing(!1, !0), _this10._editToolbar.complete(), _this10._selectedGraphic = null, _this10._mapView.container.style.cursor = g.default);
        };

        t.add(this._mapView.on("drag", function (t) {
          isDrawing() && t.stopPropagation(), "end" !== t.action && (_this10._isDragging = !0);
        })), t.add(this._mapView.on("pointer-down", function (t) {
          _this10._mouseIsDown = !0;
        })), t.add(this._mapView.on("pointer-move", function (t) {
          var e = {
            include: [_this10._layer]
          };

          _this10._mapView.hitTest(t, e).then(function (t) {
            if (t.results.length) {
              "point" === t.results[0].graphic.geometry.type && (_this10._mapView.container.style.cursor = g.pointer);
            } else _this10._mapView.container.style.cursor = g.default;
          });
        })), t.add(this._mapView.on("double-click", function (t) {
          isDrawing() && !_this10._isValidDrawing && t.stopPropagation();
        })), t.add(this._mapView.on("pointer-up", function (t) {
          var e = isDrawing(),
              i = _this10._isDragging;
          if (e) return;
          var o = {
            include: [_this10._layer]
          };
          _this10._mapView.hitTest(t, o).then(function (t) {
            t.results.length ? onMouseUp(t.results[0].graphic) : onClickOffFeature(e, i);
          }), _this10._mouseIsDown = !1, _this10._isDragging = !1, isDrawing() || t.stopPropagation();
        }));
      }
    }, {
      key: "getSymbol",
      value: function getSymbol(t, e) {
        return "point" === t ? 1 === e ? this._pointHighlightSymbol : this._pointSymbol : "polyline" === t ? 1 === e ? this._polylineHighlightSymbol : this._polylineSymbol : 1 === e ? this._polygonHighlightSymbol : this._polygonSymbol;
      }
    }, {
      key: "removeGraphic",
      value: function removeGraphic(t) {
        var _this11 = this;

        this._mapObjects.stopEditing(), this._mapObjects.modify({
          add: [],
          remove: [t]
        }), this._editToolbar.update(t.graphic).then(function () {
          _this11._editToolbar.delete();
        });
      }
    }, {
      key: "resetEditing",
      value: function resetEditing(t, e) {
        this._acreageLabel.clear(), this._mapObjects.stopEditing(), this._editingFeature = null, t && this._editToolbar.cancel(), e && this.setSymbols();
      }
    }, {
      key: "setSymbols",
      value: function setSymbols(t) {
        var _this12 = this;

        this._layer.graphics.forEach(function (e) {
          if (t && t.attributes && e.attributes && e.attributes.id === t.attributes.id) e.attributes.highlighted = 1;else {
            if (!e.geometry) return;
            e.attributes || (e.attributes = {}), e.attributes.highlighted = 0, e.symbol = _this12.getSymbol(e.geometry.type, 0);
          }
        });
      }
    }, {
      key: "isValidPolygon",
      value: function isValidPolygon(t) {
        var e = i.simplify(t);
        return e && (1 === e.rings.length || !d.lastEdgeSelfIntersects(t));
      }
    }]);

    return Editor;
  }()
});
export { u as n };